<template>
  <dialog-zoomer v-on:close="lbHide" v-model="viz">
    <div class="close-box small grey" v-on:click="lbHide"></div>
    <div class="loc-dialog sg-dialog">
      <div class="logo">
        <img v-if="!animation" src="@/assets/img/illustrationx.svg" width="178" />
        <img v-if="animation" src="@/assets/img/animationx.svg" width="178" />
      </div>
      <div class="frown-text">
        Would you prefer to browse our {{ desc }} website?
      </div>
      <div class="button-panel" style="margin-bottom:0">
        <small-button v-on:click="goSuggested">take me there</small-button>
        &nbsp;
        <small-button v-on:click="stayCurrent">no thanks</small-button>
      </div>
    </div>
  </dialog-zoomer>
</template>

<script>
import DialogZoomer from './DialogZoomer.vue'
import '@/css/my-area.css'

export default {
  props: {
    suggested: String,
    value: Boolean
  },
  components: {
    DialogZoomer
  },
  data() {
    return {
      viz: false,
      desc: ''
    }
  },
  computed: {
    animation() {
      return (this.$route.path.indexOf('/animat') >= 0)
    }
  },
  created() {
    if(this.suggested) {
      this.init()
    }
  },
  methods: {
    lbHide: async function () {
      this.viz = false
      this.$emit('input', false)
    },
    init() {
      let ln = this.suggested.toLowerCase()
      this.desc = this.$nippets.sitesDesc[ln]
      if(!this.desc) {
        this.desc = 'UK'
      }
    },
    stayCurrent() {
      this.$store.commit('setLangPref', this.$store.state.lang)
      this.lbHide()
    },
    goLang(lg) {
      if(this.$store.state.lang !== lg){
        
        this.$store.commit('setLang', lg)
        //this.$ixr.push(this.$ixr.path)
        window.location = this.$ixr.path
      }
    },
    goSuggested() {
      if(this.suggested === 'DE') {
        window.location = 'https://www.illustratoren.de/'
      }
      else {
        this.$store.commit('setLangPref', this.suggested)
        this.goLang(this.suggested)
        this.lbHide()
      }
      
    }
  },
  watch: {
    suggested() {
      this.init()
    },
    value() {
      this.viz = this.value
    }
  }

}
</script>

<style>
.loc-dialog{
  width:90vw;
  max-width: 450px;
  background-color:#e8e8e3;
  z-index:50010;
  padding:45px;
  cursor:default;
  max-height:90vh;
  overflow-y:auto;
  box-sizing: border-box;
  border-radius:6px;
}

.frown-text{
  color:#8b6f4b;
  font-size:21px;
  margin:20px 0;
}
</style>